// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"6dade3d1","488":"e9e39010"}[chunkId] + ".chunk.js";
};